import { getHours, getMinutes, getTime, set } from 'date-fns';

export function setCurrentTime(date: number | Date, time: number | Date): number {
  return getTime(set(date, { hours: getHours(time), minutes: getMinutes(time) }));
}
